import scrollIntoView from 'scroll-into-view';
import moment from 'moment';

function addTokenToOptions(token, options) {
  const newOptions = Object.assign({ headers: {} }, options);
  newOptions.headers['Authorization'] = `Bearer ${(token || {}).access_token}`;
  return newOptions;
}

export function tokenizeRequestParams(token) {
  return function(url, options, ...rest) {
    return [url, addTokenToOptions(token, options), ...rest];
  };
}

export function preventDefault(fn) {
  return function(e) {
    e.preventDefault();
    return fn(e);
  };
}

export function thousandSeparator(number) {
  const [leftPart, rightPart] = number.toString().split('.');
  const parsedRightPart =
    rightPart && rightPart.length === 2
      ? rightPart
      : rightPart && rightPart.length === 1
      ? `${rightPart}0`
      : '00';
  const parsedLeftPart = leftPart
    .split('')
    .reverse()
    .map((item, idx) => (idx % 3 === 0 && idx !== 0 ? `${item},` : item))
    .reverse()
    .join('');
  return [parsedLeftPart, parsedRightPart].join('.');
}

export function fromToDateParser(fromDate, toDate) {
  if (!fromDate && !toDate) return;
  const sameDate = moment(fromDate).isSame(toDate);
  return `${
    toDate && !sameDate
      ? `${moment(fromDate).format('MM/DD')} - ${moment(toDate).format(
          'MM/DD/YY'
        )}`
      : `${moment(fromDate).format('MM/DD/YY')}`
  }`;
}

export function getPatientProviderId({ patient, providerId }) {
  return `${patient.id}_${providerId}`;
}

export function getNoteKey(doc) {
  return `${doc.noteId}`;
}

export const scrollToElement = (
  element,
  { duration = 400, topOffset = 100 } = {}
) => {
  const scrollElement =
    typeof element === 'string' ? document.querySelector(element) : element;
  scrollIntoView(scrollElement, {
    time: duration,
    align: { top: 0, left: 0, topOffset },
  });
};

export const scrollToError = (dataScrollId, opts) =>
  scrollToElement(`[data-scroll-id="${dataScrollId}"]`, opts);

export const scrollToHighlighted = (dataScrollId, opts) =>
  scrollToElement(`[data-id="${dataScrollId}"]`, opts);

export const initPageItems = (id, itemsCount, arr) => {
  const viewedIdx = arr.findIndex((item) => {
    const itemId = item.noteId ? item.noteId : item.invoiceId;
    return itemId === Number(id);
  });
  const pagesCount = Math.round((viewedIdx + 1) / itemsCount);
  return pagesCount === 0 ? itemsCount : itemsCount + itemsCount * pagesCount;
};

export const getColorByTextValue = (text) => {
  const colorCfg = {
    A: '#C52827',
    B: '#EB407A',
    C: '#AC1457',
    D: '#AA47BC',
    E: '#6A1B9A',
    F: '#4528A0',
    G: '#00636D',
    H: '#F89782',
    I: '#00786A',
    J: '#4CB6AC',
    K: '#398D3F',
    L: '#7DB343',
    M: '#807615',
    N: '#C0CA33',
    O: '#6E4C40',
    P: '#303E9F',
    Q: '#1976D3',
    R: '#04A9F5',
    S: '#01BCD5',
    T: '#FAC02E',
    U: '#FF8F00',
    V: '#EE6D00',
    W: '#BF360C',
    X: '#E64A19',
    Y: '#9E9E9E',
    Z: '#596C7A',
  };
  return (text && colorCfg[text[0].toUpperCase()]) || undefined;
};